import { TEOLoader, InputText, Checkbox, IconButton } from '@teo/components';
import { ChevronDown, Search, ChevronUp } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useGet } from '@/query';
import { PaginationAnything } from '@/components/DataTable/PaginationAnything';

const NodeItem = ({
  item,
  exists = false,
  hendleAdd,
  hendleDelete,
  listProfiles,
  professionId,
}) => {
  const [isExists, steIsExists] = useState(
    listProfiles?.some((el) => el.professionId === professionId)
  );

  useEffect(() => {
    steIsExists(listProfiles?.some((el) => el.professionId === professionId));
  }, [exists]);

  const handleMandatory = (item, isCheck) => {
    steIsExists(isCheck);
    if (isCheck) {
      hendleAdd(item);
    } else {
      hendleDelete(item);
    }
  };

  return (
    <div className={`flex w-full rounded-lg border`}>
      <div className="flex w-full items-center gap-2 px-3 py-2 text-black">
        <div
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Checkbox
            checked={isExists}
            onChange={(isChecked) => {
              handleMandatory(item, isChecked);
            }}
          />
        </div>
        <p>{item?.name || item?.professionName}</p>
      </div>
    </div>
  );
};

const AddProfileList = ({
  setDeleteList,
  deleteList,
  setAddList,
  addList,
  oldProfiles,
  listProfiles,
  setNewProfiles,
  organisationId,
  targetType,
}) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user;

  const [showAddList, setShowAddList] = useState(false);

  const [loadProfiles, setLoadProfiles] = useState(true);
  const [sort, setSort] = useState([{ id: 'name', desc: false }]);

  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 250);
    return () => clearTimeout(t);
  }, [filter]);

  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.professionId));

    const resultList = [
      ...oldProfiles.filter((item) => !deletedIds.has(item.professionId)),
      ...addList.map((item) => ({
        ...item,
        professionId: item?.id,
        professionName: item?.name,
      })),
    ];
    setNewProfiles(resultList);
  }, [addList, deleteList, oldProfiles]);

  const hendleDelete = (item) => {
    const elId = item?.professionId ? item?.professionId : item?.id;
    const existsAdd = addList?.find((el) => el?.professionId === elId);
    if (existsAdd) {
      setAddList((prev) => prev?.filter((el) => el?.professionId !== elId));
    } else {
      const delId = listProfiles?.find((el) => el?.professionId === elId);
      setDeleteList((prev) => [
        ...prev,
        { ...item, professionId: elId, delId: delId?.id },
      ]);
    }
  };
  const hendleAdd = (item) => {
    const existsDelete = deleteList?.find((el) => el?.professionId === item.id);
    if (existsDelete) {
      setDeleteList((prev) =>
        prev?.filter((el) => el?.professionId !== item.id)
      );
    } else {
      setAddList((prev) => [...prev, { ...item, professionId: item?.id }]);
    }
  };

  return (
    <div className="-ml-6 -mr-6 -mt-6 flex flex-col overflow-y-auto pt-6">
      <div className="flex flex-col gap-1">
        <div className="mb-3 flex flex-col px-6">
          <h3 className="mb-2 text-base">
            {targetType === 'team'
              ? t(
                  'pages.create_edit_course.competence_profile_add.add_prof_title_team'
                )
              : t(
                  'pages.create_edit_course.competence_profile_add.add_prof_title'
                )}
          </h3>
          <p className="text-sm text-grey-06">
            {targetType === 'team'
              ? t(
                  'pages.create_edit_course.competence_profile_add.add_prof_text_team'
                )
              : t(
                  'pages.create_edit_course.competence_profile_add.add_prof_title'
                )}
          </p>
          {listProfiles?.length > 0 && (
            <div className="mb-2 flex w-full flex-col gap-2 border-b py-6">
              <div className="flex items-center gap-2 rounded-md bg-grey-01 px-4 py-1">
                {' '}
                {listProfiles?.length}{' '}
                {listProfiles?.length > 1
                  ? t(
                      'pages.create_edit_course.competence_profile_add.competencies_prof'
                    )
                  : t(
                      'pages.create_edit_course.competence_profile_add.competence_prof'
                    )}
                <div className="ml-auto">
                  <IconButton
                    Icon={showAddList ? ChevronUp : ChevronDown}
                    ariaLabel="Search"
                    onClick={() => setShowAddList(!showAddList)}
                    variant="ghost"
                  />
                </div>
              </div>
              {showAddList &&
                listProfiles?.map((item) => {
                  return (
                    <NodeItem
                      key={item?.professionId}
                      item={item}
                      exists={true}
                      hendleAdd={hendleAdd}
                      hendleDelete={hendleDelete}
                      listProfiles={listProfiles}
                      professionId={item?.professionId}
                    />
                  );
                })}
            </div>
          )}
        </div>

        <div className={`relative mb-2 px-6`}>
          <InputText
            value={filter}
            onChange={(ev) => setFilter(ev.target.value)}
            Icon={Search}
            placeholder={t(
              'pages.create_edit_course.competence_profile_add.search'
            )}
          />
        </div>

        <div className="mt-2 flex w-full flex-col px-6">
          {loadProfiles && (
            <div className="mx-auto flex justify-center py-20 px-10">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[100px]"
              />
            </div>
          )}
          <PaginationAnything
            className={`mt-3 flex w-full flex-col gap-2 ${
              loadProfiles === true && ' hidden '
            }`}
            fetch={useGet.bind(null, '/professions', {
              lang: authUser?.lang,
              organisationId: `${organisationId},OR,organisationId=null`,
              onSuccess: (result) => {
                setLoadProfiles(false);
              },
            })}
            empty={{
              template: 2,
              loadContent: loadProfiles,
              text: t('empty_tenplate.course_list'),
            }}
            defaultSort={sort}
            page={0}
            pageSize={10}
            filter={debouncedFilter}
            render={(item) => {
              const isExists = listProfiles?.find(
                (el) => el.professionId === item.id
              );
              return (
                <NodeItem
                  key={item?.id}
                  item={item}
                  exists={isExists}
                  hendleAdd={hendleAdd}
                  hendleDelete={hendleDelete}
                  listProfiles={listProfiles}
                  professionId={item?.id}
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddProfileList;
